import React, { FC, InputHTMLAttributes } from 'react';
import '../form.scss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  methods?: any;
  wrapperClass?: string;
  className?: string;
  labelClass?: string;
}

const Input: FC<InputProps> = ({ methods, name, label, wrapperClass, labelClass, ...rest }) => {
  const {
    register,
    formState: { errors }
  } = methods;

  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className={`${labelClass} text-neutral9 font-semibold`} htmlFor={name}>
          {label}
        </label>
      )}
      <input
        id={name}
        className="input"
        aria-invalid={errors ? 'true' : 'false'}
        {...register(name)}
        {...rest}
      />
      {errors[name] && (
        <span className="error" role="alert">
          {errors[name].message}
        </span>
      )}
    </div>
  );
};

export default Input;
